module.exports = __webpack_public_path__ + "static/img/stay-option-icon-bathroom.87a3748e.svg";